// import React, { useEffect } from "react";
// import Autocomplete from "@mui/material/Autocomplete";
// import { CircularProgress, TextField } from "@mui/material";

// export default function Asynchronous(props) {
//   const { getOptionLabel, Service, value, inputProps, variant, ...rest } =
//     props;

//   const [inputValue, setInputValue] = React.useState("");
//   const [options, setOptions] = React.useState([]);
//   const [open, setOpen] = React.useState(false);
//   const [loading, setLoading] = React.useState(false);

//   const handleInputValueChange = (e, newValue) => {
//     setInputValue(newValue);
//     newValue.length > 0 ? setLoading(true) : setOptions([]);
//     newValue.length >= 3 &&
//       newValue.length <= 12 &&
//       (async () => {
//         const response = await Service(newValue);
//         setOptions(response);
//         setLoading(false);
//       })();
//   };

//   useEffect(() => {
//     open && options.length === 0 && setLoading(true);
//   }, [open, options.length]);

//   return (
//     <Autocomplete
//       autoHighlight
//       open={open}
//       onClose={() => {
//         setOpen(false);
//       }}
//       onOpen={() => {
//         setOpen(true);
//       }}
//       clearOnEscape
//       value={value === "" ? null : value}
//       getOptionLabel={
//         getOptionLabel
//           ? getOptionLabel
//           : (option) => option.name + " | " + option.barcode
//       }
//       {...rest}
//       options={options}
//       loading={loading}
//       inputValue={inputValue}
//       onInputChange={handleInputValueChange}
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           {...inputProps}
//           variant={variant ? variant : "outlined"}
//           InputProps={{
//             ...params.InputProps,
//             endAdornment: (
//               <React.Fragment>
//                 {loading && open ? (
//                   <CircularProgress color="inherit" size={15} />
//                 ) : null}
//                 {params.InputProps.endAdornment}
//               </React.Fragment>
//             ),
//           }}
//         />
//       )}
//     />
//   );
// }


import React, { useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress, TextField } from "@mui/material";

export default function Asynchronous(props) {
  const {
    getOptionLabel,
    Service,
    value,
    inputProps,
    variant,
    isResultEmpty,
    ...rest
  } = props;

  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  // const handleInputValueChange = async (e, newValue) => {
  //   const trimmedValue = newValue.trim()
  //   setInputValue(trimmedValue);
    
  //   trimmedValue.length > 0 ? setLoading(true) : setOptions([]);
  //   // if (trimmedValue.length >= 3 && trimmedValue.length <= 12) {
  //   //   const response = await Service(trimmedValue);
  //   //     setOptions(response);
  //   //     setLoading(false);
  //   // }

  //   trimmedValue.length >= 3 &&
  //     trimmedValue.length <= 12 &&
  //     (async () => {
  //       const response = await Service(trimmedValue);
  //       setOptions(response);
  //       setLoading(false);

  //       // Automatically select if only one option is available
  //       // if (response.length === 1) {
  //       //   onChange(null, response[0]); // Trigger onChange with the selected option
  //       //   setInputValue(
  //       //     getOptionLabel
  //       //       ? getOptionLabel(response[0])
  //       //       : response[0].name + " | " + response[0].barcode
  //       //   );
  //       // }
  //     })();
  //   // }
  // };
  const handleInputValueChange = async (e, newValue) => {
    const trimmedValue = newValue.trim()
    setInputValue(trimmedValue);

    trimmedValue.length > 0 ? setLoading(true) : setOptions([]);

    if (trimmedValue.length >= 1 && trimmedValue.length <= 10) {
      try {
        const response = await Service(trimmedValue);
        setOptions(response)

        const emptyDataSet = { responseEmpty: !response.length, trimmedValue }

        isResultEmpty(e, emptyDataSet)

        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.log(error);

      }
    } 
  };
  useEffect(() => {
    open && options.length === 0 && setLoading(true);
    if (open && options.length === 0) {
      setLoading(true);
    }
  }, [open, options.length]);

  return (
    <Autocomplete
      autoHighlight
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => {
        setOpen(true);
      }}
      freeSolo // Prevents sending request continuosly after option selected.
      disableClearable // Prevents sending request continuosly after option selected.
      clearOnEscape
      value={value === "" ? null : value}
      getOptionLabel={
        getOptionLabel
          ? getOptionLabel
          : (option) => option.name + " | " + option.barcode
      }
      {...rest}
      options={options}
      loading={loading}
      inputValue={inputValue}
      onInputChange={handleInputValueChange}
      // onChange={onChange} // Ensure the parent component receives updates
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProps}
          variant={variant ? variant : "outlined"}
          name="customerSearchAsyncAutoComplete"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading && open ? (
                  <CircularProgress color="inherit" size={15} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}